import CheckboxGroup from './CheckboxGroup.vue'

export default CheckboxGroup
